'use client'

import {
    Box,
    VStack,
    HStack,
    Text,
    Image,
    useBreakpointValue,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import Marquee from "react-fast-marquee";

export default function LogoCarousel3() {
    const { t } = useTranslation();
    const breakpoint = useBreakpointValue({ base: 'base', sm: 'sm', md: 'md', lg: 'lg', xl: 'xl' });
    const isMobile = breakpoint === 'base' || breakpoint === 'sm';

    const logos = [
        { src: "/duke_logo.jpg", alt: "Duke University Logo", height: "3.65rem" },
        { src: "/harvard_logo.jpg", alt: "Harvard Logo", height: "4rem" },
        { src: "/tubi_logo.png", alt: "Tubi Logo", height: "2.9rem" },
        { src: "/brown_logo.jpg", alt: "Brown Logo", height: "2.3rem" },

        { src: "/amazon_logo.png", alt: "Amazon Logo", height: "3.75rem" },
        { src: "/mit_logo.png", alt: "MIT Logo", height: "3.2rem" },
        { src: "/yale_logo.png", alt: "Yale Logo", height: "3.5rem" },
        { src: "/bcg_logo.png", alt: "BCG Logo", height: "3.21rem" },
        { src: "/stanford_logo.png", alt: "Stanford Logo", height: "2.8rem" },
        { src: "/slack_logo.jpg", alt: "Slack Logo", height: "3.5rem" },
    ];

    return (
        <Box
            width="100vw"
            mb="3.3rem"
            justify="center"
            align="center"
            flexDirection={isMobile ? 'column' : 'row'}
            mt={0}
            display="flex"
            justifyContent="center"
            alignItems={isMobile ? 'center' : 'flex-start'}
            py="0rem"
            overflow="hidden"
            position="relative"
        >
            <VStack spacing={9}>
                <Text color="#64748b" fontSize={19} fontWeight="medium" textAlign={'center'} px={isMobile ? 4 : 0}>
                    Trusted by 1 million+ students, researchers, and professionals
                </Text>
                {/* <Text fontSize={20} fontWeight="600">
                    {t("Trusted by 1 million+ students, researchers, and professionals")}
                </Text> */}
                {isMobile ? (
                    <VStack spacing={12} bg="white">
                        {logos.slice(0,4).map((logo, index) => (
                            <Image key={index} src={logo.src} alt={logo.alt} height={logo.height} />
                        ))}
                    </VStack>
                ) : (
                    <Box
                        display="flex"
                        overflow="hidden"
                        width="100vw"
                    >
                        <Marquee speed={50} autoFill={true} gradient={true} gradientWidth={200}>
                            {logos.map((logo, index) => (
                                <Image key={index} src={logo.src} alt={logo.alt} height={logo.height} mr={14}
                                       mt={logo.alt === "Amazon Logo" ? 1 : 0}/>
                            ))}
                        </Marquee>
                    </Box>
                )}
            </VStack>
        </Box>
    );
}
